module.exports = __webpack_public_path__ + "static/media/Economist_Logo.e3911ef5.png";